const { merge, mapObj } = require('ramda')

function postStreamFactory (streams, spec) {
  return merge(streams, mapObj(streams.main.map, spec))
}

module.exports = postStreamFactory
